type FormattedTextProps = {
  readonly children: string;
};

export function FormattedText({ children }: FormattedTextProps) {
  return children.split(/((?<!\*)\*\*[^*]+\*\*(?!\*))/g).map((part, index) =>
    index % 2 === 1 ? (
      <strong key={index} className="font-bold">
        {part.slice(2, -2)}
      </strong>
    ) : (
      part
    ),
  );
}
